import React, { FC } from 'react'

import { acquisitionFilterOptions } from '@new/__global/components/Filters/Filters.constants'

import { BookingAcquisitionView, FiltersSharedProps } from './Filters.types'
import { RadioBasedField } from './FiltersVariations/Radio'

interface AcquisitionFilterProps extends FiltersSharedProps {
  title: string
  onChange: (value?: BookingAcquisitionView) => void
  initialValue?: BookingAcquisitionView
}

export const AcquisitionFilter: FC<AcquisitionFilterProps> = props => {
  return (
    <RadioBasedField
      radioGroupId="acquisitionFilterFilterGroup"
      options={acquisitionFilterOptions}
      {...props}
    />
  )
}
